<template>
    <div class="layout-login">
        <!-- <div class="login-role" v-if="showRole">
            <div class="role1" @click="userType=1;userInfo.LoginType = 1;showRole=false">
                <div class="role-info">
                    <div class="info-img">
                        <img alt="Vue logo" src="../assets/man_img.png">
                    </div>
                    <div class="info-text">
                        <span>我是首席推荐人</span>
                    </div>
                </div>
            </div>
            <div class="role2" @click="userType=2;userInfo.LoginType = 2;showRole=false">
                <div class="role-info">
                    <div class="info-img"><img alt="Vue logo" src="../assets/man_img.png"></div>
                    <div class="info-text">
                        <span>我是城市合伙人</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-operate" v-if="!showRole">
            <div class="operate-sub">
                <div class="sub-close">
                    <img style="width: 18px;" @click="userType=null;userInfo.LoginType = 0;showRole=true;userInfo.UserName='';userInfo.Password=''" src="../assets/img/login_close.png" alt="">
                </div>
                <div class="sub-form">
                    <mt-field :state="userInfo.name_state" label="用户名" @keyup.enter.native.capture="userLoginClick()" placeholder="请输入用户名" v-model="userInfo.UserName"></mt-field>
                    <mt-field :state="userInfo.pass_state" label="密码" @keyup.enter.native.capture="userLoginClick()" placeholder="请输入密码" type="password" v-model="userInfo.Password"></mt-field>
                    <mt-button class="submit-btn" size="large" type="primary" @click.native="userLoginClick()">登录</mt-button>
                </div>
            </div>
        </div> -->
        <h3 style="text-align: center;margin-top: 200px">客户经理登录</h3>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userInfo: {
                UserName: '',
                Password: '',
                SchoolID: '',
                LoginType: 0,
                name_state: '',
                pass_state: ''
            },
            userSchoolInfo: null,
            userType: null,
            showRole: true,
            requestUrl: 'https%3a%2f%2fagent.product.52bkb.com%2f%23%2f'
        }
    },
    methods: {
        userLoginClick() {
            let _this = this;
            _this.userInfo.UserName = _this.abp.globalFun.trim(_this.userInfo.UserName);
            if(_this.userInfo.UserName&&_this.userInfo.Password) {
                _this.$indicator.open('加载中...');
                if(_this.userType == 1) {
                    _this.abp.api.GetSchoolsOfUser(_this.userInfo.UserName)
                        .then((res)=> {
                            if(res.status == 200) {
                                if(res.data.IsSuccess) {
                                _this.userInfo.SchoolID = res.data.Data[0].ID;
                                // 调用老师登录接口
                                _this.abp.api.TeacherLogin(_this.userInfo)
                                    .then((res2)=> {
                                        if(res2.status == 200) {
                                            if(res2.data.IsSuccess) {
                                                if(res2.data.Data.Teacher.IsSpread){
                                                    sessionStorage.setItem('AuthorizationBearer',res2.data.Data.Token);
                                                    sessionStorage.setItem('UserInfo',_this.abp.f_Base64.encode(JSON.stringify(res2.data.Data.Teacher)));
                                                    sessionStorage.setItem('userType',_this.abp.f_Base64.encode('agent_teacher'));
                                                    localStorage.setItem('userlog',_this.abp.f_Base64.encode(JSON.stringify(_this.userInfo)));
                                                    _this.abp.UserInfos.userInfo = res2.data.Data.Teacher;
                                                    _this.$indicator.close();
                                                    _this.$router.replace(this.$route.query.redirect || '/home' );
                                                }else{
                                                    _this.$indicator.close();
                                                    _this.abp.api.reqSuccess(_this,'您不是推荐人，不可以登录系统')
                                                }
                                            }else{
                                                _this.$indicator.close();
                                                _this.abp.api.reqSuccess(_this,res2.data.OutputMessage)
                                            }
                                        }
                                    })
                                }else{
                                    _this.$indicator.close();
                                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                }
                            }
                        })
                        .catch((error)=> {
                            let _this = this;
                            _this.$indicator.close();   
                            _this.abp.api.reqSuccess(this,error?_this.res.data.OutputMessage:'登录出错!')
                        })
                }else if(_this.userType == 2){
                    _this.abp.api.AgentSignIn(_this.userInfo)
                        .then((res)=> {
                            if(res.status == 200) {
                                if(res.data.IsSuccess) {
                                    sessionStorage.setItem('AuthorizationBearer',res.data.Data.Token);
                                    sessionStorage.setItem('UserInfo',_this.abp.f_Base64.encode(JSON.stringify(res.data.Data.Agent)));
                                    sessionStorage.setItem('userType',_this.abp.f_Base64.encode('agenter'));
                                    localStorage.setItem('userlog',_this.abp.f_Base64.encode(JSON.stringify(_this.userInfo)));
                                    _this.abp.UserInfos.userBearer = res.data.Data.Token;
                                    _this.abp.UserInfos.userInfo = res.data.Data.Agent;
                                    _this.$indicator.close();
                                    _this.$router.replace(this.$route.query.redirect || '/home' );
                                }else{
                                    _this.$indicator.close();
                                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                }
                            }
                        })
                        .catch((error)=> {
                            let _this = this;
                            _this.$indicator.close();
                            _this.abp.api.reqSuccess(this,error?_this.res.data.OutputMessage:'登录出错!')
                        })
                }
            }else{
                this.$toast({
                    message: '用户名和密码不能为空！',
                    duration: 2000
                });
            }
        },
    },
  mounted() {
    let _this = this,
        reg = new RegExp('(^|&)code=([^&]*)(&|$)');
    _this.requestUrl = _this.abp.api.Hosts;
    let r = window.location.search.substr(1).match(reg);
    if(r != null) {
      _this.$indicator.open('加载中...');
      _this.abp.api.AgentSignInWXPublic({ Code: r[2] })
        .then((res) => {
          if(res.status == 200) {
            if(res.data.IsSuccess) {
              _this.$indicator.close();
                sessionStorage.setItem('AuthorizationBearer',res.data.Data.Token);
                sessionStorage.setItem('UserInfo',_this.abp.f_Base64.encode(JSON.stringify(res.data.Data.Agent)));
                _this.abp.UserInfos.userInfo = res.data.Data.Agent;
                _this.abp.UserInfos.userBearer = res.data.Data.Token;
                _this.abp.UserInfos.userGuanZhu = res.data.Data.Subscribe == 1 ? true : false;
                _this.abp.UserInfos.userIsBind = res.data.Data.IsBind;
                localStorage.setItem('Subscribe',res.data.Data.Subscribe);
                sessionStorage.setItem('userIsBind',res.data.Data.IsBind);
                _this.$router.replace(this.$route.query.redirect || '/home' );
            }else{
                _this.$indicator.close();
                _this.abp.UserInfos.userBearer = null;
                try {
                  _this.abp.UserInfos.userGuanZhu = res.data.Data.Subscribe == 1 ? true : false;
                  localStorage.setItem('Subscribe',res.data.Data.Subscribe);
                } catch (e) {
                  _this.abp.UserInfos.userGuanZhu = false;
                  console.log(e);
                }
                if(res.data.OutputMessage == '用户不存在！'){
                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fregister&response_type=code&scope=snsapi_base#wechat_redirect'
                }else if(res.data.OutputMessage == '用户微信信息验证错误'){
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2flogin&response_type=code&scope=snsapi_base#wechat_redirect'
                }
            }
          }
        })
        .catch((error)=>{
            _this.$indicator.close();
            try {
                switch(error.status) {
                    case 401:
                    _this.abp.api.reqSuccess(_this,'您没有权限！')
                }
            } catch (txt) {
                console.log(txt);
            }
        })
    }else{
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2flogin&response_type=code&scope=snsapi_base#wechat_redirect'
    }
  }
}
</script>


<style>
    .layout-login {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: #f5f5f5;
    }
    /* 角色选择 */
    .layout-login>.login-role {
        position: absolute;
        top: 50%;
        left: 20px;
        right: 20px;
        height: 400px;
        margin: auto;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        display: flex;
        overflow: auto;
    }
    /* .layout-login>.login-role>.role1 {
        border-bottom: 1px solid #ccc;
    } */
    .layout-login>.login-role>.role1,
    .layout-login>.login-role>.role2 {
        flex: 1;
        height: 200px;
        display: flex;
        flex-direction: column;
    }
    .layout-login>.login-role .role-info {
        height: 200px;
        width: 200px;
        margin: auto;
        text-align: center;
        cursor: pointer;
        display: flex;
        flex-direction: column;
    }
    .layout-login>.login-role .role-info>.info-img{
        height: 150px;
        width: 150px;
        margin: auto;
        border-radius: 150px;
        overflow: hidden;
    }
    .layout-login>.login-role .role-info>.info-text {
        height: 50px;
        line-height: 50px;
    }
    /* 登录界面 */
    .layout-login>.login-operate {
        position: absolute;
        top: 10px;
        left: 10px;
        right: 10px;
        bottom: 10px;
        overflow: auto;
    }
    .layout-login>.login-operate>.operate-sub {
        width: 100%;
        height: 400px;
        max-width: 600px;
        margin: auto;
        margin-top: 50px;
    }
    .layout-login>.login-operate>.operate-sub>.sub-close {
        height: 100px;
    }
    .layout-login>.login-operate>.operate-sub>.sub-close>img {
        cursor: pointer;
    }
    .layout-login>.login-operate>.operate-sub>.sub-form {
        height: 300px;
    }
    .submit-btn {
        margin-top: 50px;
    }
    @media (max-width: 768px) {
        .layout-login>.login-role {
            flex-direction: column;
        }
    }
    @media (min-width: 768px) {
        .layout-login>.login-role {
            flex-direction: row;
        }
    
    }
</style>

